// extracted by mini-css-extract-plugin
export default {"secondaryBannerDarkBlock":"SecondaryBannerDarkBlock_secondaryBannerDarkBlock__Cd0M2","secondaryBanner":"SecondaryBannerDarkBlock_secondaryBanner__ZS00l"};